import { Box, Typography, Tooltip } from "@mui/material";
import { Eye, EyeOff } from "lucide-react";

interface ClientOutputVisibleIndicatorProps {
  visible: boolean;
  onClick?: () => void;
  disabled?: boolean;
  showLabel?: boolean;
  size?: number;
}

export default ({
  visible,
  onClick,
  disabled = false,
  showLabel = true,
  size = 18,
}: ClientOutputVisibleIndicatorProps) => {
  const isClickable = !!onClick && !disabled;

  return (
    <Tooltip
      title={
        visible ? "Output visible to clients" : "Output hidden from clients"
      }
    >
      <Box
        onClick={isClickable ? onClick : undefined}
        sx={{
          display: "flex",
          alignItems: "center",
          gap: "6px",
          cursor: isClickable ? "pointer" : "default",
          userSelect: "none",
          color: visible ? "success.main" : "text.tertiary",
          opacity: disabled ? 0.5 : 1,
          pointerEvents: disabled ? "none" : "auto",
        }}
      >
        {visible ? <Eye size={size} /> : <EyeOff size={size} />}
        {showLabel && (
          <Typography
            variant="body"
            sx={{
              fontSize: "13px",
              color: visible ? "success.main" : "text.tertiary",
            }}
          >
            Client visible
          </Typography>
        )}
      </Box>
    </Tooltip>
  );
};
